import { Button, OverlayTrigger, Popover,Tooltip } from "react-bootstrap"

interface PopoverProps {
    content: React.ReactNode
}

export const OverlayPopover: React.FC<PopoverProps> = (props) => {
    return   <OverlayTrigger overlay={( <Popover>{ props.content }</Popover>)} placement="top" trigger="click">
                <Button size="sm">?</Button>
            </OverlayTrigger>
}

interface HelpTipProps {
    content: React.ReactNode
}

export const HelpTip: React.FC<HelpTipProps> = (props) => {
    return   <OverlayTrigger overlay={( <Tooltip>{ props.content }</Tooltip>)} placement="top" trigger="click">
                <Button size="sm" className="mx-1">?</Button>
            </OverlayTrigger>
}